/* tslint:disable */
/* eslint-disable */
/**
 * Marco Email Parser API
 * Marco Email Parser API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SupportRecomputeReferralCreditsResponse
 */
export interface SupportRecomputeReferralCreditsResponse {
    /**
     * 
     * @type {string}
     * @memberof SupportRecomputeReferralCreditsResponse
     */
    userId: string;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupportRecomputeReferralCreditsResponse
     */
    qualifyingBookingIds: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof SupportRecomputeReferralCreditsResponse
     */
    appliedBookingIds: Array<number>;
}

/**
 * Check if a given object implements the SupportRecomputeReferralCreditsResponse interface.
 */
export function instanceOfSupportRecomputeReferralCreditsResponse(value: object): value is SupportRecomputeReferralCreditsResponse {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('qualifyingBookingIds' in value) || value['qualifyingBookingIds'] === undefined) return false;
    if (!('appliedBookingIds' in value) || value['appliedBookingIds'] === undefined) return false;
    return true;
}

export function SupportRecomputeReferralCreditsResponseFromJSON(json: any): SupportRecomputeReferralCreditsResponse {
    return SupportRecomputeReferralCreditsResponseFromJSONTyped(json, false);
}

export function SupportRecomputeReferralCreditsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SupportRecomputeReferralCreditsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['user_id'],
        'qualifyingBookingIds': json['qualifying_booking_ids'],
        'appliedBookingIds': json['applied_booking_ids'],
    };
}

export function SupportRecomputeReferralCreditsResponseToJSON(json: any): SupportRecomputeReferralCreditsResponse {
    return SupportRecomputeReferralCreditsResponseToJSONTyped(json, false);
}

export function SupportRecomputeReferralCreditsResponseToJSONTyped(value?: SupportRecomputeReferralCreditsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'user_id': value['userId'],
        'qualifying_booking_ids': value['qualifyingBookingIds'],
        'applied_booking_ids': value['appliedBookingIds'],
    };
}

